import React, { useState, useEffect, useMemo } from 'react';
import { Timestamp } from 'firebase/firestore';
import Modal from './Modal';

const EGRESO_PARTIDAS = [
    "Sueldos", "Alimentación y Viáticos", "Combustible y Lubricantes",
    "Mensajeros", "Gastos de Transporte", "Publicidad y Mercadeo",
    "Útiles de Oficina", "Mantenimiento y Reparaciones", "Servicios",
    "Otros Gastos Operativos", "Anticipo de Sueldos", "Liquidaciones"
].sort();

function GastoFormModal({ isOpen, onClose, onSave, currentGasto, isLoading, showAppModal }) {
    const defaultGastoData = useMemo(() => ({
        fecha: new Date().toISOString().slice(0,10),
        descripcion: '',
        partida: EGRESO_PARTIDAS.length > 0 ? EGRESO_PARTIDAS[0] : '',
        observaciones: '',
        monto: ''
    }), []);

    const [gastoData, setGastoData] = useState(defaultGastoData);

    useEffect(() => {
        if (isOpen) {
            if (currentGasto) {
                setGastoData({
                    ...defaultGastoData,
                    ...currentGasto,
                    fecha: currentGasto.fecha instanceof Timestamp
                           ? currentGasto.fecha.toDate().toISOString().slice(0,10)
                           : (typeof currentGasto.fecha === 'string' ? currentGasto.fecha : defaultGastoData.fecha),
                    monto: currentGasto.monto != null ? String(currentGasto.monto) : ''
                });
            } else {
                setGastoData(defaultGastoData);
            }
        }
    }, [currentGasto, isOpen, defaultGastoData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setGastoData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!gastoData.fecha || !gastoData.descripcion || !gastoData.partida || !gastoData.monto) {
            showAppModal("Campos Incompletos", "Por favor, complete todos los campos obligatorios del gasto: Fecha, Descripción, Partida y Monto.");
            return;
        }
        onSave({ ...gastoData, monto: parseFloat(gastoData.monto) });
    };

    if (!isOpen) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={currentGasto ? "Editar Egreso" : "Registrar Nuevo Egreso"}>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="gastoFecha" className="block text-sm font-medium text-gray-700">Fecha *</label>
                    <input type="date" name="fecha" id="gastoFecha" value={gastoData.fecha} onChange={handleChange} required className="input-field mt-1"/>
                </div>
                <div>
                    <label htmlFor="gastoDescripcion" className="block text-sm font-medium text-gray-700">Descripción *</label>
                    <input type="text" name="descripcion" id="gastoDescripcion" value={gastoData.descripcion} onChange={handleChange} required className="input-field mt-1"/>
                </div>
                 <div>
                    <label htmlFor="gastoPartida" className="block text-sm font-medium text-gray-700">Partida *</label>
                    <select name="partida" id="gastoPartida" value={gastoData.partida} onChange={handleChange} required className="input-field mt-1 bg-white">
                        {EGRESO_PARTIDAS.map(p => <option key={p} value={p}>{p}</option>)}
                    </select>
                </div>
                <div>
                    <label htmlFor="gastoMonto" className="block text-sm font-medium text-gray-700">Monto (Q) *</label>
                    <input type="number" step="0.01" name="monto" id="gastoMonto" value={gastoData.monto} onChange={handleChange} required placeholder="0.00" className="input-field mt-1"/>
                </div>
                 <div>
                    <label htmlFor="gastoObservaciones" className="block text-sm font-medium text-gray-700">Observaciones</label>
                    <textarea name="observaciones" id="gastoObservaciones" value={gastoData.observaciones} onChange={handleChange} rows="2" className="input-field mt-1"></textarea>
                </div>
                <div className="flex justify-end space-x-3 pt-3">
                    <button type="button" onClick={onClose} disabled={isLoading} className="btn-secondary">Cancelar</button>
                    <button type="submit" disabled={isLoading} className="btn-primary">
                        {isLoading ? "Guardando..." : (currentGasto ? "Actualizar Egreso" : "Guardar Egreso")}
                    </button>
                </div>
            </form>
        </Modal>
    );
}

export default GastoFormModal;